import { ModalContent, ModalFooter } from '@components/modal';

const DeleteModal = ({ deleteClick, projectName, requestType }) => (
  <ModalContent title='Confirm Cancellation'>
    <section className='modal-body'>
      <div>
        <p>Are you sure you want to cancel this request?</p>
        <ul>
          <li>
            <b>Request Type:</b> {requestType}
          </li>
          <li>
            <b>Request Name:</b> {projectName}
          </li>
        </ul>
      </div>
    </section>
    <ModalFooter onSave={() => deleteClick()} saveText='Yes' cancelText='No' onCancel={() => {}} />
  </ModalContent>
);

export default DeleteModal;
